module.exports = __webpack_public_path__ + "img/TV GLOBO.45936214.png";